import { useParams } from 'react-router';

import { useCurrentUserRolesForWebcastQuery } from '../../../generated/graphql-manager';

export function useCurrentUserRolesForWebcast(eventId?: string) {
  const { webcastId = '' } = useParams();

  const currentWebcastId = eventId || webcastId || '';

  const { data } = useCurrentUserRolesForWebcastQuery({
    variables: { webcastId: currentWebcastId },
    skip: !currentWebcastId,
  });

  const currentUserRoles = data?.currentUserRolesForWebcast || [];
  const isOnlyModeratorForEvent = currentUserRoles.length === 1 && currentUserRoles[0] === 'MODERATOR';

  return {
    currentUserRoles,
    isOnlyModeratorForEvent,
  };
}
